/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum GlobalFailureStatus {
  mass_replay_down = 'mass_replay_down',
  payment_issue = 'payment_issue',
  plan_limit = 'plan_limit',
}

export enum MemberRole {
  admin = 'admin',
  member = 'member',
  owner = 'owner',
}

export enum TaskAggregationInterval {
  daily = 'daily',
  monthly = 'monthly',
  yearly = 'yearly',
}

export enum TaskHeldReason {
  access_blacklisted_app = 'access_blacklisted_app',
  blacklisted_app = 'blacklisted_app',
  dedupe_change = 'dedupe_change',
  paymentIssue = 'paymentIssue',
  plan_limit = 'plan_limit',
  stale_auth = 'stale_auth',
  step_limit = 'step_limit',
  task_limit = 'task_limit',
  throttled = 'throttled',
  too_many = 'too_many',
  unknown = 'unknown',
}

export enum TaskNodeType {
  node = 'node',
  path = 'path',
  pathGroup = 'pathGroup',
}

export enum TaskStatus {
  delayed = 'delayed',
  delete = 'delete',
  deleted = 'deleted',
  error = 'error',
  filtered = 'filtered',
  halted = 'halted',
  held = 'held',
  pending = 'pending',
  replay = 'replay',
  scheduled = 'scheduled',
  skipped = 'skipped',
  success = 'success',
  throttled = 'throttled',
  unknown = 'unknown',
}

export enum ZapNodeType {
  filter = 'filter',
  read = 'read',
  search = 'search',
  search_or_write = 'search_or_write',
  write = 'write',
}

export enum ZapState {
  draft = 'draft',
  off = 'off',
  on = 'on',
}

export interface AccountInput {
  companiesTrialAutoUpgrade?: boolean | null;
  dataRetentionDays?: number | null;
  isAutoReplayEnabled?: boolean | null;
  logoChoice?: string | null;
  name?: string | null;
  trialAutoUpgrade?: boolean | null;
}

export interface DateRangeType {
  to?: string | null;
  from?: string | null;
}

export interface TaskFilter {
  app?: string | null;
  customuserId?: string | null;
  folderId?: string | null;
  limit?: number | null;
  periodEnd?: string | null;
  periodStart?: string | null;
  query?: string | null;
  rootId?: string | null;
  status?: string[] | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
